module.exports = {"TXTCLI_LoadingXX":{"id":"TXTCLI_LoadingXX","defaultMessage":"Se încarcă...","flags":["TRACK"],"track":"Loading..."}}